var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationDarkOutline({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11643",
    "data-name": "Group 11643",
    transform: "translate(0 -4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18008",
    "data-name": "Rectangle 18008",
    width: 32,
    height: 32,
    transform: "translate(0 4)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11643-2",
    "data-name": "Group 11643",
    transform: "translate(5 6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12726",
    "data-name": "Path 12726",
    d: "M68.454,264.968H46.633a.565.565,0,0,1-.422-.931l1.933-2.309a2.212,2.212,0,0,0,.513-1.417V251.96a8.963,8.963,0,0,1,8.887-9.038h0a8.963,8.963,0,0,1,8.886,9.038v8.351a2.212,2.212,0,0,0,.513,1.417l1.934,2.309A.566.566,0,0,1,68.454,264.968Z",
    transform: "translate(-46.076 -242.922)",
    fill: "none",
    stroke: "#455079",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11498",
    "data-name": "Group 11498",
    transform: "translate(8.53 25.065)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12727",
    "data-name": "Path 12727",
    d: "M55.3,264.588a2.935,2.935,0,0,0,2.935-2.935H52.361A2.935,2.935,0,0,0,55.3,264.588Z",
    transform: "translate(-52.361 -261.653)",
    fill: "#455079"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationDarkOutline);
export default __webpack_public_path__ + "static/media/notification-dark-outline.069d0528710e3ffab528261371d66f73.svg";
export { ForwardRef as ReactComponent };